// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import Tables from './pages/Tables';
import Sessions from './pages/Sessions';
import Billing from './pages/Billing';
import Settings from './pages/Settings';
import Admin from './pages/Admin';

// Protected route — blocks unauthenticated users and redirects admins away from merchant pages
const ProtectedRoute = ({ children }) => {
  const { user, isAdmin, adminMerchant, loading } = useAuth();
  if (loading) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#F7F4EF', fontFamily: "'Outfit', sans-serif", color: '#aaa', fontSize: '14px',
    }}>
      Loading...
    </div>
  );
  if (!user) return <Navigate to="/signin" replace />;
  if (isAdmin && !adminMerchant) return <Navigate to="/admin" replace />;
  return <Layout>{children}</Layout>;
};

// Public route — redirect to correct home if already logged in
const PublicRoute = ({ children }) => {
  const { user, isAdmin, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={isAdmin ? '/admin' : '/dashboard'} replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/signin"    element={<PublicRoute><SignIn /></PublicRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/tables"    element={<ProtectedRoute><Tables /></ProtectedRoute>} />
      <Route path="/sessions"  element={<ProtectedRoute><Sessions /></ProtectedRoute>} />
      <Route path="/billing"   element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/settings"  element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/admin"     element={<Admin />} />
      <Route path="*"          element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&family=Outfit:wght@300;400;500;600;700&display=swap');
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
          body { font-family: 'Outfit', sans-serif; background: #F7F4EF; }
          button { font-family: 'Outfit', sans-serif; }
        `}</style>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}